import { action } from 'satcheljs';
import { ItemCacheLockId } from '../store/schema/ItemCacheLockId';
import { CacheItem } from '../store/schema/CacheItem';
import { CacheDescriptor } from '../store/schema/CacheDescriptor';

export const updateItem = action(
    'updateItem',
    <T extends CacheItem>(key: string, itemId: string, itemUpdates: Partial<T>) => ({
        key,
        itemId,
        itemUpdates,
    })
);

export const replaceItems = action(
    'replaceItems',
    <T extends CacheItem>(key: string, items: T[]) => ({
        key,
        items,
    })
);

export const upsertItemsForDescriptor = action(
    'upsertItemsForDescriptor',
    <T extends CacheItem, U extends CacheDescriptor>(
        key: string,
        lockId: ItemCacheLockId,
        items: T[],
        descriptor: U
    ) => ({
        key,
        lockId,
        items,
        descriptor,
    })
);

export const addItem = action('addItem', <T extends CacheItem>(key: string, item: T) => ({
    key,
    item,
}));

export const deleteItem = action('deleteItem', (key: string, itemId: string) => ({ key, itemId }));
